document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll(".faq-item");
  const showMoreBtn = document.querySelector(".show-more-btn");

  // Accordion toggle (only one open at a time per column group)
  faqItems.forEach(item => {
    const button = item.querySelector(".faq-question");

    button.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // close only items in the same column
      const parentWrapper = item.closest(".faq-wrapper");
      parentWrapper.querySelectorAll(".faq-item").forEach(i => {
        i.classList.remove("active");
        i.querySelector(".faq-question").setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        item.classList.add("active");
        button.setAttribute("aria-expanded", "true");
      }
    });
  });

  // Show more toggle
  if (showMoreBtn) {
    showMoreBtn.addEventListener("click", () => {
      document.querySelectorAll(".hidden-faq").forEach(item => {
        item.classList.toggle("hidden");
      });
      showMoreBtn.textContent = 
        showMoreBtn.textContent === "Show More" ? "Show Less" : "Show More";
    });
  }
});